import { createAsyncThunk, current } from '@reduxjs/toolkit';
import axios from 'axios';

export const initStateCreateTopUp = {
  createTopUp: { data: null, loading: false, error: null },
};

export const createTopUp = createAsyncThunk('order/createTopUp', async (data, { rejectWithValue, fulfillWithValue }) => {
  return await axios
    .post(`${process.env.REACT_APP_SERVER_API}/order/create-topup`, data, { headers: { 'auth-token': localStorage.getItem('auth-token') } })
    .then((res) => {
      return fulfillWithValue(res.data);
    })
    .catch((res) => {
      return rejectWithValue(res.response.data);
    });
});

export const reducerCreateTopUp = {
  [createTopUp.pending]: (state) => {
    state.createTopUp.loading = true;
  },
  [createTopUp.fulfilled]: (state, action) => {
    state.createTopUp.loading = false;
    state.createTopUp.data = action.payload;
    state.createTopUp.error = null;
  },
  [createTopUp.rejected]: (state, action) => {
    state.createTopUp.loading = false;
    state.createTopUp.error = action.payload;
  },
};
